import React, { useState } from "react";
import styled from "@emotion/styled";
import { useHistory } from "react-router";
import ServiceWrapper from "../components/ServiceWrapper";
import { api } from "../utils/api";
import auth from "../utils/auth";
import { track } from "../utils/track";

/** 악보 신청 (새 디자인, 2026-10): 곡 제목·가수를 적어 보내면 운영자가 만들어 올린다 (POST /user/score/request) */
const RequestScore: React.FC = () => {
  const history = useHistory();
  const [title, setTitle] = useState("");
  const [singer, setSinger] = useState("");
  const [state, setState] = useState<"idle" | "sending" | "done" | "error">("idle");

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!title.trim() || !singer.trim()) return;
    setState("sending");
    track("request:send");
    try {
      const url = auth.getToken() ? "/user/score/request" : "/score/request";
      const { data } = await api.post(url, { score_title: title.trim(), score_singer: singer.trim() });
      setState(data && data.success === false ? "error" : "done");
    } catch (err) {
      setState("error");
    }
  };

  return (
    <ServiceWrapper isFooterRendered={false}>
      <Page>
        <h1>악보 신청</h1>
        {state === "done" ? (
          <Done>
            <strong>신청했어요</strong>
            <span>
              「{title}」 · {singer}
              <br />
              악보가 올라오면 알림으로 알려드려요.
            </span>
            <div>
              <button type="button" onClick={() => { setTitle(""); setSinger(""); setState("idle"); }}>다른 곡 신청</button>
              <button type="button" className="primary" onClick={() => history.push("/")}>홈으로</button>
            </div>
          </Done>
        ) : (
          <Form onSubmit={submit}>
            <p>치고 싶은 곡이 없나요? 곡 제목과 가수를 알려주시면 악보를 만들어 올려드려요.</p>
            <label>
              <span>곡 제목</span>
              <input value={title} onChange={(e) => setTitle(e.target.value)} placeholder="예: 소년만화" />
            </label>
            <label>
              <span>가수</span>
              <input value={singer} onChange={(e) => setSinger(e.target.value)} placeholder="예: QWER" />
            </label>
            <button type="submit" disabled={!title.trim() || !singer.trim() || state === "sending"}>
              {state === "sending" ? "보내는 중…" : "신청하기"}
            </button>
            {state === "error" && <Err>신청하지 못했어요. 잠시 뒤 다시 시도해 주세요.</Err>}
            <Small>궁금한 점이나 불편한 점은 <button type="button" onClick={() => history.push("/support")}>문의하기</button>로 남겨 주세요.</Small>
          </Form>
        )}
      </Page>
    </ServiceWrapper>
  );
};

export default RequestScore;

const Page = styled.div`
  width: 100%;
  max-width: 560px;
  margin: 0 auto;
  box-sizing: border-box;
  padding: 16px 20px 110px;
  color: #f3f4f6;
  & > h1 {
    margin: 0 0 16px;
    font-size: 24px;
    font-weight: 700;
    color: #f3f4f6;
  }
`;

const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 16px;
  & > p {
    margin: 0;
    font-size: 15px;
    line-height: 1.6;
    color: #a3a9b5;
    word-break: keep-all;
  }
  & > label {
    display: flex;
    flex-direction: column;
    gap: 6px;
  }
  & > label > span {
    font-size: 13px;
    color: #a3a9b5;
  }
  & > label > input {
    height: 50px;
    padding: 0 14px;
    border-radius: 12px;
    border: 1px solid #2a2e38;
    background: #16181e;
    color: #f3f4f6;
    font-size: 16px;
    outline: 0;
  }
  & > label > input:focus {
    border-color: #5b8cff;
  }
  & > button {
    height: 54px;
    border-radius: 14px;
    border: 0;
    background: #5b8cff;
    color: #0d0e12;
    font-size: 16px;
    font-weight: 700;
    cursor: pointer;
  }
  & > button:disabled {
    background: #2a2e38;
    color: #7c8392;
  }
`;

const Done = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  padding: 40px 0;
  text-align: center;
  & > strong {
    font-size: 20px;
  }
  & > span {
    font-size: 15px;
    line-height: 1.6;
    color: #a3a9b5;
  }
  & > div {
    display: flex;
    gap: 8px;
    width: 100%;
    margin-top: 12px;
  }
  & > div > button {
    flex: 1;
    height: 50px;
    border-radius: 14px;
    border: 1px solid #2a2e38;
    background: transparent;
    color: #f3f4f6;
    font-size: 15px;
    cursor: pointer;
  }
  & > div > button.primary {
    border: 0;
    background: #5b8cff;
    color: #0d0e12;
    font-weight: 700;
  }
`;

const Err = styled.p`
  margin: 0;
  font-size: 14px;
  color: #ff9a9a;
  text-align: center;
`;

const Small = styled.p`
  margin: 0;
  font-size: 13px;
  color: #7c8392;
  text-align: center;
  & > button {
    border: 0;
    background: none;
    padding: 0;
    color: #8fb0ff;
    font-size: 13px;
    cursor: pointer;
  }
`;
